var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrangeMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.0390625C4.25362 0.0390625 0 4.25831 0 9.46228C0 14.6663 4.25362 18.8855 9.5 18.8855C14.7464 18.8855 19 14.6663 19 9.46228C19 4.25831 14.7464 0.0390625 9.5 0.0390625ZM13.9009 6.85558L9.35038 13.7546C9.34919 13.7557 9.34681 13.7569 9.34681 13.7581C9.32306 13.7934 9.31 13.8335 9.28031 13.8665C9.23875 13.9112 9.18531 13.9348 9.13781 13.9689C9.12594 13.9772 9.11406 13.9866 9.101 13.9948C9.02738 14.0408 8.95138 14.0714 8.86825 14.0914C8.84094 14.0985 8.816 14.1056 8.7875 14.1103C8.72136 14.1193 8.65434 14.1201 8.588 14.1126C8.54114 14.1097 8.49464 14.1026 8.44906 14.0914C8.40203 14.0774 8.35634 14.0592 8.3125 14.0373C8.2745 14.0196 8.23413 14.0149 8.1985 13.9925C8.17238 13.976 8.15812 13.9501 8.13556 13.9301C8.12606 13.9218 8.11419 13.9195 8.10469 13.9112L5.45538 11.4812C5.29834 11.3316 5.20673 11.1269 5.20023 10.9111C5.19373 10.6952 5.27286 10.4855 5.42062 10.3269C5.56838 10.1683 5.77297 10.0735 5.99042 10.0629C6.20786 10.0523 6.42081 10.1268 6.5835 10.2703L8.50131 12.0301L12.5091 5.95331C12.6297 5.77024 12.8187 5.64221 13.0345 5.59736C13.2503 5.55252 13.4753 5.59455 13.6598 5.7142C13.8444 5.83384 13.9735 6.02132 14.0187 6.23537C14.0639 6.44942 14.0215 6.67252 13.9009 6.85558Z",
    fill: "#E8993D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMark);
export default __webpack_public_path__ + "static/media/orange_mark.a27b81ffd07f9ade8035a3abecae0fb9.svg";
export { ForwardRef as ReactComponent };